module.exports = __webpack_public_path__ + "img/DSC_7330.78190e02.jpg";